import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { WithEntityProps } from '@/entity/components/with-entity';
import { AUDIT_TRAILS_ID } from '@/entity/constants';
type IncompleteBannerProps = WithEntityProps;
const IncompleteBanner = t0 => {
  const $ = _c(17);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "incompleteBanner"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isBusiness = entity.kind === "business";
  if (entity.status === "incomplete") {
    let t2;
    if ($[1] !== entity.workflows) {
      t2 = [...entity.workflows].sort(_temp);
      $[1] = entity.workflows;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const [latestWorkflow] = t2;
    let t3;
    if ($[3] !== latestWorkflow?.source || $[4] !== t) {
      t3 = latestWorkflow?.source === "hosted" ? t(_temp2) : t(_temp3);
      $[3] = latestWorkflow?.source;
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const personText = t3;
    let t4;
    if ($[6] !== isBusiness || $[7] !== personText || $[8] !== t) {
      t4 = isBusiness ? t(_temp4) : personText;
      $[6] = isBusiness;
      $[7] = personText;
      $[8] = t;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const text = t4;
    const handleViewAuditTrail = _temp5;
    let t5;
    if ($[10] !== t) {
      t5 = t(_temp6);
      $[10] = t;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t5) {
      t6 = {
        label: t5,
        onClick: handleViewAuditTrail
      };
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t6 || $[15] !== text) {
      t7 = <div className="mb-6"><InlineAlert variant="warning" cta={t6}>{text}</InlineAlert></div>;
      $[14] = t6;
      $[15] = text;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  return null;
};
export default IncompleteBanner;
function _temp(a, b) {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
function _temp2($) {
  return $.header.person;
}
function _temp3($_0) {
  return $_0.header.incomplete;
}
function _temp4($_1) {
  return $_1.header.business;
}
function _temp5() {
  document.getElementById(AUDIT_TRAILS_ID)?.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
function _temp6($_2) {
  return $_2.viewAuditTrail;
}